import { heroStats } from "@/mocks/movieData";

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[640px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20moody%20urban%20night%20scene%20with%20warm%20amber%20street%20light%2C%20rain%20glossed%20pavement%20reflections%2C%20blurred%20city%20bokeh%20lights%2C%20dramatic%20film%20noir%20atmosphere%2C%20rich%20deep%20shadows%20and%20soft%20golden%20highlights%2C%20wide%20letterbox%20composition&width=1920&height=1080&seq=hero-cinema-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/80 to-foreground-950/55" />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-transparent to-foreground-950/40" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-center">
          <div className="lg:col-span-7 animate-float-up">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/15 border border-accent-400/40 text-accent-200 text-xs md:text-sm font-label">
              <i className="ri-fire-line text-accent-300" /> 无删减完整版 · 观影指引
            </span>
            <h1 className="mt-5 text-3xl md:text-5xl font-bold text-background-50 leading-tight">
              嫂子的诱惑
              <span className="block mt-2 text-xl md:text-3xl font-bold text-accent-300">
                无删减完整版 · 剧情与观看全指南
              </span>
            </h1>
            <p className="mt-5 text-sm md:text-base text-background-200 leading-relaxed max-w-xl">
              一站式整理剧情梗概、人物关系、画质差异、播放线路与下载收藏要点。无论你想先了解完整版讲了什么，
              还是快速定位高清画质与合适的观看方式，都可以从这一页开始。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#lines"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-play-circle-line text-lg" /> 查看播放线路
              </a>
              <a
                href="#plot"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 text-sm md:text-base font-medium whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-colors"
              >
                <i className="ri-book-open-line text-lg" /> 剧情与看点
              </a>
            </div>

            <div className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-xl">
              {heroStats.map((stat) => (
                <div key={stat.label} className="border-l-2 border-accent-400/60 pl-3">
                  <div className="text-lg md:text-xl font-bold text-accent-300 font-heading">{stat.value}</div>
                  <div className="text-xs text-background-300 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 flex justify-center lg:justify-end">
            <div className="relative w-64 sm:w-72 lg:w-80">
              <div className="absolute -inset-3 rounded-2xl bg-accent-500/10 border border-accent-400/20" />
              <div className="relative rounded-xl overflow-hidden border border-background-50/15">
                <div className="w-full aspect-[3/4]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20poster%20style%20portrait%20of%20a%20confident%20graceful%20woman%20in%20warm%20amber%20light%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20crimson%20and%20gold%20tones%2C%20soft%20film%20grain%2C%20moody%20theatrical%20atmosphere%2C%20refined%20and%20classy%2C%20blurred%20warm%20interior%20background&width=800&height=1100&seq=cover-drama-01&orientation=portrait"
                    alt="《嫂子的诱惑》无删减完整版封面海报"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/90 to-transparent p-4">
                  <div className="flex items-center gap-2 text-accent-300 text-xs font-label">
                    <i className="ri-verified-badge-line" /> 完整版收录 · 保留全部剧情
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}